export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import type {MenuProps} from 'kpc';

export default class extends Component {
    static template = template;

    static defaults() {
        return {
            expandedKeys: ['3'],
            size: 'large' as MenuProps['size'],
            theme: 'light' as MenuProps['theme'],
            type: 'vertical' as MenuProps['type'],
            collapse: false,
        };
    }
}